export default Object.freeze([
  { keys: ['eid'], subscriptions: ['events', 'scores'], path: ['events'] },
  {
    keys: ['eid', 'mtid'],
    subscriptions: ['currentLines', 'consensus', 'liveLines'],
    path: ['events', 'currentLines'],
  },
])
